(function() {
	'use strict';

	angular.module('resultUploadedCollectionApp').factory('ResultUploadedService',
			ResultUploadedService);

	ResultUploadedService.$inject = [ '$resource', '$window' ];

	function ResultUploadedService($resource, $window) {
		var reportUrl = GLOBAL_URL + 'api/ga/report';
		
		return $resource(GLOBAL_URL + 'api/resultUploaded/:uri', {
			uri : '@uri'
		}, {
			'downloadReport' : {
				url : reportUrl + '/result-uploaded-collection',
				method : 'POST',
				responseType : 'arraybuffer',
				transformResponse : [ function(data, header) {
					var header = header();
					downLoad(data, header['file-type'],
							header['file-export']);
				} ],
			},
			'postList' : {
				method : 'POST',
				isArray : true
			},
			'post' : {
				method : 'POST'
			},
			'get' : {
				method : 'GET'
			}
		});
		
		function downLoad(response, type, fileName) {
			var file = new Blob([ response ], {
				type : type
			});
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				$window.navigator.msSaveBlob(file, fileName);
			} else { // for other browsers
				var fileURL = $window.URL.createObjectURL(file);
				// Test tren chorme va firefox
				var theAnchor = $('<a />').attr('href', fileURL).attr(
						'download', fileName).appendTo('body');
				theAnchor[0].click();
				theAnchor.remove();
			}

		};
	}
})();